<template>
  <section>
    <div class="tip" style="margin: 20px 0 0 40px">* 合同内容</div>
    <!-- <div class="clear">
      <el-form-item label="所属项目">
        <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
      </el-form-item>
    </div> -->
    <el-form-item class="underline-label" label="已线下通过该审批">
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p
        class="tip"
        v-if="form.underLine == '1'"
        style="padding: 0 10px; border: 1px #d93c37 solid"
      >
        *已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。
      </p>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item class="important-label" label="*合同名称">
          <el-input
            size="small"
            placeholder="请输入合同名称"
            v-model="form.name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.ctype != 0">
        <el-form-item label="合同编号">
          <el-input
            size="small"
            placeholder="合同编号选填(不填写合同编号系统将自动生成)"
            v-model="form.number"
          ></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item class="important-label" label="*合同种类">
      <!-- '工程施工合同','物资采购合同','服务类合同','借款合同','担保合同','低值易耗品','其他合同' -->

      <!-- trpeArrOld 需要新老判断 -->
      <!-- 旧：1   新：2 -->
      <div v-if="form.id && form.flow.edition == '1'">
        <!-- 旧类型 -->
        <el-radio
          v-model="form.type"
          v-for="(item, i) in typeArrOld"
          :key="i"
          :label="i"
          >{{ item }}</el-radio
        >
      </div>
      <div v-else-if="form.ctype == 1">
        <!-- 新-合同类型-集团 -->
        <el-radio
          v-model="form.type"
          v-for="(item, i) in typeArrJT"
          :key="i"
          :label="i"
          >{{ item }}</el-radio
        >
      </div>
      <div v-else>
        <!-- 新-合同类型-子公司 -->
        <el-radio
          v-model="form.type"
          v-for="(item, i) in typeArrZGS"
          :key="i"
          :label="i"
          >{{ item }}</el-radio
        >
      </div>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item class="important-label" label="*合同对方">
          <el-input
            size="small"
            placeholder="请输入合同对方"
            v-model="form.customer"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="important-label" label="*合同价款(元)">
          <el-input
            size="small"
            type="number"
            placeholder="请输入合同价款(元)"
            v-model="form.price"
          ></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item v-if="form.ctype == 0" label="合同金额">
      <el-checkbox v-model="form.isLowcost"
        >8万以下工程合同或5万以下监理设计合同（如果是请勾选）</el-checkbox
      >
    </el-form-item>
    <div class="clear" v-if="form.ctype != 0">
      <el-col :span="12">
        <el-form-item label="是否大客户">
          <el-radio v-model="form.isBigCustomer" label="1">是</el-radio>
          <el-radio v-model="form.isBigCustomer" label="0">否</el-radio>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否重大合同">
          <el-radio v-model="form.isBigContract" label="1">是</el-radio>
          <el-radio v-model="form.isBigContract" label="0">否</el-radio>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.ctype == 2">
        <el-form-item label="是否'一户一表'工程">
          <el-radio v-model="form.isYhyb" label="1">是</el-radio>
          <el-radio v-model="form.isYhyb" label="0">否</el-radio>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="合同概要">
      <el-input
        type="textarea"
        placeholder="请输入合同概要"
        :autosize="{ minRows: 4, maxRows: 8 }"
        size="small"
        v-model="form.outline"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="form.ctype != 0" label="合同款项结算内容">
      <el-input
        type="textarea"
        placeholder="请输入合同款项结算内容"
        :autosize="{ minRows: 4, maxRows: 8 }"
        size="small"
        v-model="form.content"
      ></el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input
        type="textarea"
        placeholder="请输入备注"
        :autosize="{ minRows: 2, maxRows: 6 }"
        size="small"
        v-model="form.remark"
      ></el-input>
    </el-form-item>

    <div class="tip" style="margin: 0 0 0 40px">* 承办单位</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="承办单位（部门）" label-width="175px">
          <el-input
            size="small"
            :disabled="true"
            placeholder="请输入承办单位（部门）"
            v-model="project.leader.department.split('/')[0]"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="承办人" label-width="175px">
          <el-input
            size="small"
            :disabled="true"
            placeholder="请输入承办人"
            v-model="project.leader.name"
          ></el-input>
        </el-form-item>
      </el-col>
    </div>
  </section>
</template>

<script>
export default {
  props: ["project", "formByFather", "userData"],
  data() {
    return {
      form: {},

      typeArrOld: [
        "工程施工合同",
        "物资采购合同",
        "服务类合同",
        "借款合同",
        "担保合同",
        "低值易耗品",
        "其他合同",
      ],
      typeArrJT: [
        "采购类框架合同",
        "客户服务合同",
        "融资、担保合同",
        "其他合同",
      ],
      typeArrZGS: [
        "工程施工合同",
        "工程服务合同",
        "物资采购合同",
        "服务采购合同",
        "其他合同",
      ],
    };
  },
  mounted() {
    this.form = this.formByFather;

    // this.form.depId = this.userData.secDepIds.split(",")[0]
    // this.form.leaderId = this.userData.id
  },
  methods: {
    getFromData() {
      if (!this.form.name || !this.form.customer) {
        this.$message.error("所有标红项目均是必填项，请仔细检查您的填写内容");
        return;
      }

      return this.form;
    },
  },
  watch: {
    formByFather() {
      this.form = this.formByFather;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/form/createContractApproval.vue